document.addEventListener('DOMContentLoaded', () => {
    function init() {
        const cartForms = document.querySelectorAll<HTMLElement>('.single-product .product-summary, .product-order, .woocommerce-cart .cart-products .cart-product');

        cartForms?.forEach(cartForm => {
            const cartTotal = cartForm.querySelector<HTMLElement>('.add-to-cart_total, .product-subtotal');
            const cartTotalAmount = cartTotal?.querySelector<HTMLElement>('.total-amount, .amount bdi');
            const input = cartForm.querySelector<HTMLInputElement>('.quantity input.qty');
            const select = cartForm.querySelector<HTMLSelectElement>('select.qty-select');

            const status = cartForm.querySelector('.product-status');
            const bar = status?.querySelector<HTMLElement>('.product-status-bar');

            if (!input) {
                return;
            }

            const curCount = parseFloat(bar?.getAttribute('data-cur-count') ?? '0');
            const minCount = parseFloat(bar?.getAttribute('data-min-count') ?? '0');
            const price = parseFloat(cartForm.getAttribute('data-price') ?? '0');

            const maxQtyAttr = input.getAttribute('max');
            const MAX_QTY = maxQtyAttr ? parseFloat(maxQtyAttr) : 999999;

            const formatter = new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
            });

            if (select.value) {
                select.dispatchEvent(new Event('change', {bubbles: true}));
            }

            select?.addEventListener('change', () => {
                const value = select.value;

                if (value) {
                    input.value = value;
                    input.dispatchEvent(new Event('input', {bubbles: true}));
                }
            })

            input.addEventListener('input', () => {
                const raw = parseFloat(input.value);
                let val = isNaN(raw) ? 0 : Math.min(MAX_QTY, raw);

                if (raw > MAX_QTY) {
                    input.value = String(MAX_QTY);
                }

                if (bar && minCount > 0) {
                    const newPerc = Math.round(((val + curCount) / minCount) * 10000) / 100;
                    bar.style.setProperty('--potential-percent', `${newPerc}%`);
                }

                if (cartTotalAmount && cartTotal) {
                    cartTotalAmount.textContent = val > 0 ? formatter.format(val * price) : '€ 0,00';

                    const overflows = cartTotalAmount.scrollWidth > cartTotal.clientWidth;
                    cartTotalAmount.style.transform = overflows
                        ? `scale(${cartTotal.clientWidth / cartTotalAmount.scrollWidth})`
                        : '';
                }
            });
        });
    }

    init();

    window.addEventListener('woocommerce_cart_updated', init);
});